module.exports = new __parcel__URL__("bossfight_boss_epic.d4f1ce7b.png").toString();